<template>
    <div :class="classname" class="block-theme__icons">
        <i class="svg-icon" :class="'svg-icon__' + classname + '-1'"></i>
        <i class="svg-icon" :class="'svg-icon__' + classname + '-2'"></i>
        <i class="svg-icon" :class="'svg-icon__' + classname + '-3'"></i>
        <i class="svg-icon" :class="'svg-icon__' + classname + '-4'"></i>
    </div>
</template>

<script>
export default {
    props: {
        themes: {
            type: Array,
            default() {
                return [];
            }
        },
        classname: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.block-theme__icons {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    pointer-events: none;
}

.svg-icon:nth-child(1) {
    position: absolute;
    z-index: 10;
    right: 20px;
    opacity: 0.2;
    top: 20%;
    height: 180px;
    width: 180px;
    transform: translateY(20%) rotate(35deg);
}

.svg-icon:nth-child(2) {
    position: absolute;
    z-index: 10;
    left: 0;
    opacity: 0.2;
    top: 20px;
    height: 100px;
    width: 100px;
    transform: rotate(25deg);

    @include media-breakpoint-up(lg) {
        left: 50px;
    }
}

.svg-icon:nth-child(3) {
    position: absolute;
    z-index: 10;
    right: 0;
    opacity: 0.2;
    top: 0;
    height: 100px;
    width: 100px;
    transform: rotate(-15deg);

    @include media-breakpoint-up(lg) {
        right: 50%;
        top: 50px;
    }
}

.svg-icon:nth-child(4) {
    position: absolute;
    z-index: 10;
    left: 0;
    opacity: 0.2;
    bottom: 0;
    height: 100px;
    width: 100px;
    transform: rotate(-15deg);

    @include media-breakpoint-up(lg) {
        left: 50%;
        bottom: 50px;
    }
}
</style>
